import { Cookies } from 'react-cookie';

import { Client } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const deleteClient = async (id: number) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.delete(`/clients/${id}/`, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as Client;
};
